import { AxiosError, AxiosResponse } from 'axios';

import { SprayEventStartDate } from 'services/sprayEvents/types';
import {
    RequestedLoadSprayedEntitiesByDateAction,
    CanceledLoadSprayedEntitiesByDateAction,
    SuccededLoadSprayedEntitiesByDateAction,
    FailedLoadSprayedEntitiesByDateAction,
    SetSprayedEntitiesByDateAction,
    SprayedEntitiesByDateState
} from './types';
import {
    SPRAYED_ENTITIES_BY_DATE_LOAD_REQUESTED,
    SPRAYED_ENTITIES_BY_DATE_LOAD_CANCELED,
    SPRAYED_ENTITIES_BY_DATE_LOAD_SUCCEEDED,
    SPRAYED_ENTITIES_BY_DATE_LOAD_FAILED,
    SPRAYED_ENTITIES_BY_DATE_SET
} from './constants';

export function requestLoadSprayedEntitiesByDate(
    startDate: SprayEventStartDate
): RequestedLoadSprayedEntitiesByDateAction {
    return {
        type: SPRAYED_ENTITIES_BY_DATE_LOAD_REQUESTED,
        payload: startDate
    };
}

export function canceledLoadSprayedEntitiesByDate(): CanceledLoadSprayedEntitiesByDateAction {
    return {
        type: SPRAYED_ENTITIES_BY_DATE_LOAD_CANCELED
    };
}

export function succeededLoadSprayedEntitiesByDate(
    response: AxiosResponse
): SuccededLoadSprayedEntitiesByDateAction {
    return {
        type: SPRAYED_ENTITIES_BY_DATE_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadSprayedEntitiesByDate(
    payload: AxiosError
): FailedLoadSprayedEntitiesByDateAction {
    return {
        type: SPRAYED_ENTITIES_BY_DATE_LOAD_FAILED,
        payload,
        error: true
    };
}

export function setSprayedEntitiesByDate(
    entities: SprayedEntitiesByDateState
): SetSprayedEntitiesByDateAction {
    return {
        type: SPRAYED_ENTITIES_BY_DATE_SET,
        payload: entities
    };
}
